/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable object-shorthand */
import { useWindowDimensions } from 'react-native';
import { View, styles as sc } from './Themed';
import SiteHeader from './site-components/SiteHeader';
import SocialLinksFooter from './site-components/SocialLinksFooter';
import CopyrightFooter from './site-components/CopyrightFooter';
// Image assets
import BackgroundDesign from './site-components/BackgroundDesign';

type LinkMapType = Record<string, undefined | (() => void)>;
type SnapCaloriePagePropsType = {
  headerLinks: LinkMapType;
  children: React.ReactNode;
  showNavBar?: Boolean;
};
export default function SnapCalorieSitePage({ headerLinks, children, showNavBar }: SnapCaloriePagePropsType) {
  const windowDimensions = useWindowDimensions();
  return (
    <View
      key="RootElement"
      style={[sc.container, { minHeight: windowDimensions.height, width: windowDimensions.width }]}
    >
      <View
        style={{
          // flex: 1,
          flexDirection: 'column',
          justifyContent: 'flex-start',
          minHeight: 600,
          // maxWidth: 1200,
          alignSelf: 'center',
        }}
      >
        {showNavBar && (
          <>
            <SiteHeader key="Header" linkMap={headerLinks} />
            <View key="Spacer" style={{ height: 30 }} />
          </>
        )}
        {children}
      </View>
      <SocialLinksFooter />
      <CopyrightFooter />

      <BackgroundDesign />
    </View>
  );
}
SnapCalorieSitePage.defaultProps = {
  showNavBar: true,
};
